"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _get2 = _interopRequireDefault(require("@babel/runtime/helpers/get"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _textFieldHiddenSchema = _interopRequireDefault(require("./text-field-hidden-schema"));

var _createNumberMask = _interopRequireDefault(require("text-mask-addons/dist/createNumberMask"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var MASK_PROPS = ['prefix', 'suffix', 'includeThousandsSeparator', 'thousandsSeparatorSymbol', 'allowDecimal', 'decimalSymbol', 'decimalLimit', 'allowNegative'];

var NumberField = /*#__PURE__*/function (_TextFieldHiddenSchem) {
  (0, _inherits2.default)(NumberField, _TextFieldHiddenSchem);

  var _super = _createSuper(NumberField);

  function NumberField() {
    var _this;

    (0, _classCallCheck2.default)(this, NumberField);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "_className", 'NumberField');
    return _this;
  }

  (0, _createClass2.default)(NumberField, [{
    key: "_create",
    value: function _create(props) {
      (0, _get2.default)((0, _getPrototypeOf2.default)(NumberField.prototype), "_create", this).call(this, props);
      this._requireString = false;
      this.set({
        schema: {
          component: 'Form',
          fields: [{
            name: 'minValue',
            component: 'NumberField',
            label: 'Min Value',
            docLevel: 'basic',
            thousandsSeparatorSymbol: ','
          }, {
            name: 'maxValue',
            component: 'NumberField',
            label: 'Max Value',
            docLevel: 'basic',
            thousandsSeparatorSymbol: ','
          }, {
            name: 'prefix',
            component: 'TextField',
            label: 'Prefix',
            docLevel: 'basic'
          }, {
            name: 'suffix',
            component: 'TextField'
          }, {
            name: 'includeThousandsSeparator',
            component: 'BooleanField'
          }, {
            name: 'thousandsSeparatorSymbol',
            component: 'TextField'
          }, {
            name: 'allowDecimal',
            component: 'BooleanField'
          }, {
            name: 'decimalSymbol',
            component: 'TextField'
          }, {
            name: 'decimalLimit',
            component: 'IntegerField'
          }, {
            name: 'allowNegative',
            component: 'BooleanField'
          }]
        }
      });

      this._setDefaults(props, {
        unmask: /[^\d\\.]/g
      });
    }
  }, {
    key: "_validateLengths",
    value: function _validateLengths() {
      if (!this.isBlank()) {
        var value = this.getValue();
        var minValue = this.get('minValue');
        var maxValue = this.get('maxValue');

        if (minValue !== null && value < minValue) {
          this.setErr("must be ".concat(minValue, " or greater"));
        } else if (maxValue !== null && value > maxValue) {
          this.setErr("must be ".concat(maxValue, " or less"));
        }
      }
    }
  }, {
    key: "validate",
    value: function validate() {
      (0, _get2.default)((0, _getPrototypeOf2.default)(NumberField.prototype), "validate", this).call(this);

      this._validateWithRegExp(/^([+-]?\d*\.?\d*)$/, 'not a number');

      if (!this.hasErr()) {
        this._validateLengths();
      }
    }
  }, {
    key: "_shouldCreateMask",
    value: function _shouldCreateMask(props) {
      var _this2 = this;

      // Is a masked prop defined and it is changing?
      var shouldCreate = false;
      MASK_PROPS.forEach(function (name) {
        if (props[name] !== undefined && props[name] !== _this2._getProperty(name)) {
          shouldCreate = true;
        }
      });
      return shouldCreate;
    }
  }, {
    key: "_createMask",
    value: function _createMask(props) {
      var maskOpts = {
        prefix: '',
        // override default of '$'
        allowDecimal: true,
        decimalLimit: null,
        allowNegative: true
      };
      MASK_PROPS.forEach(function (name) {
        if (props[name] !== undefined) {
          maskOpts[name] = props[name];
        }
      });
      this.set({
        mask: (0, _createNumberMask.default)(maskOpts)
      });
    }
  }, {
    key: "set",
    value: function set(props) {
      // This needs to be executed before super.set() as we need to compare new and previous values of
      // the props
      if (this._shouldCreateMask(props)) {
        this._createMask(props);
      }

      (0, _get2.default)((0, _getPrototypeOf2.default)(NumberField.prototype), "set", this).call(this, props);
    }
  }, {
    key: "fromUIValue",
    value: function fromUIValue(value) {
      var decimalSymbol = this.get('decimalSymbol');

      if (decimalSymbol && decimalSymbol !== '.' && !this.isValueBlank(value)) {
        var tmpSymbol = 'A'; // Replace decimal symbol with tmp symbol

        value = value.replace(decimalSymbol, tmpSymbol); // Remove everything except number, sign and tmp symbol

        value = value.replace(/[^\d-A]/g, ''); // Replace tmp symbol with standard decimal symbol of '.'

        value = value.replace(tmpSymbol, '.');
      }

      return (0, _get2.default)((0, _getPrototypeOf2.default)(NumberField.prototype), "fromUIValue", this).call(this, value);
    }
  }, {
    key: "getUIValue",
    value: function getUIValue() {
      var value = (0, _get2.default)((0, _getPrototypeOf2.default)(NumberField.prototype), "getUIValue", this).call(this);
      var decimalSymbol = this.get('decimalSymbol');

      if (decimalSymbol && decimalSymbol !== '.' && !this.isBlank()) {
        // As per JS conventions, our values are always stored with a decimal symbol of '.'.
        // Therefore, we replace the '.' with the decimalSymbol so that we can support alternative
        // decimal symbols like Germany's ','.
        return value.replace('.', decimalSymbol);
      } else {
        return value;
      }
    }
  }]);
  return NumberField;
}(_textFieldHiddenSchema.default);

exports.default = NumberField;